{
  "AiFillApple": "ai-fill-apple",
  "BsGrid": "bs-grid",
  "BsGrid3X3Gap": "bs-grid3-x3-gap",
  "Fa500Px": "fa500-px",
  "FaApple": "fa-apple",
  "FaBlackTie": "fa-black-tie",
  "FaGoogle": "fa-google",
  "FaLink": "fa-link",
  "FaListUl": "fa-list-ul",
  "FaMapLocation": "fa-map-location",
  "FiChevronLeft": "fi-chevron-left",
  "FiChevronLeftBold": "fi-chevron-left-bold",
  "FiChevronRight": "fi-chevron-right",
  "FiInfo": "fi-info",
  "FiMail": "fi-mail",
  "FiMoreHorizontal": "fi-more-horizontal",
  "FiStar": "fi-star",
  "GiAmmoniteFossil": "gi-ammonite-fossil",
  "GiBasketballJersey": "gi-basketball-jersey",
  "GiClassicalKnowledge": "gi-classical-knowledge",
  "GiFamilyTree": "gi-family-tree",
  "GiFoxHead": "gi-fox-head",
  "GiFoxTail": "gi-fox-tail",
  "GoStack": "go-stack",
  "HanCashCoin": "han-cash-coin",
  "HanDragon": "han-dragon",
  "HanReviewAgainFace": "han-review-again-face",
  "HanReviewEasyFace": "han-review-easy-face",
  "HanReviewGoodFace": "han-review-good-face",
  "HanReviewHardFace": "han-review-hard-face",
  "HanStreakFlame": "han-streak-flame",
  "HanziZi": "hanzi-zi",
  "HiChatBubbleLeftRight": "hi-chat-bubble-left-right",
  "HiFastForward": "hi-fast-forward",
  "HiOutlineFastForward": "hi-outline-fast-forward",
  "ImTree": "im-tree",
  "IoAdd": "io-add",
  "IoBulbOutline": "io-bulb-outline",
  "IoCaretDown": "io-caret-down",
  "IoChatbubble": "io-chatbubble",
  "IoCheckmark": "io-checkmark",
  "IoChevronBack": "io-chevron-back",
  "IoChevronForward": "io-chevron-forward",
  "IoClose": "io-close",
  "IoCloseCircle": "io-close-circle",
  "IoColorFill": "io-color-fill",
  "IoColorFillOutline": "io-color-fill-outline",
  "IoEarthOutline": "io-earth-outline",
  "IoEllipsisHorizontal": "io-ellipsis-horizontal",
  "IoExtensionPuzzle": "io-extension-puzzle",
  "IoLinkOutline": "io-link-outline",
  "IoLocationOutline": "io-location-outline",
  "IoLocationSharp": "io-location-sharp",
  "IoMdBook": "io-md-book",
  "IoMdInformationCircleOutline": "io-md-information-circle-outline",
  "IoMdRedo": "io-md-redo",
  "IoMdUndo": "io-md-undo",
  "IoMic": "io-mic",
  "IoMicOff": "io-mic-off",
  "IoPersonAdd": "io-person-add",
  "IoPlayForward": "io-play-forward",
  "IoPlayForwardOutline": "io-play-forward-outline",
  "IoVideocam": "io-videocam",
  "IoVideocamOff": "io-videocam-off",
  "IoVolumeHigh": "io-volume-high",
  "IoVolumeHighOutline": "io-volume-high-outline",
  "IoVolumeMute": "io-volume-mute",
  "LuAlertTriangle": "lu-alert-triangle",
  "LuBatteryCharging": "lu-battery-charging",
  "LuBookMarked": "lu-book-marked",
  "LuBookOpen": "lu-book-open",
  "LuBrain": "lu-brain",
  "LuCalendar": "lu-calendar",
  "LuCheck": "lu-check",
  "LuCheckBold": "lu-check-bold",
  "LuCheckCheckbox": "lu-check-checkbox",
  "LuCheckCheckboxWeb": "lu-check-checkbox-web",
  "LuChevronDown": "lu-chevron-down",
  "LuChevronRight": "lu-chevron-right",
  "LuChevronUp": "lu-chevron-up",
  "LuComponent": "lu-component",
  "LuEye": "lu-eye",
  "LuEyeOff": "lu-eye-off",
  "LuFlame": "lu-flame",
  "LuHelpCircle": "lu-help-circle",
  "LuKeyboard": "lu-keyboard",
  "LuLibrary": "lu-library",
  "LuListOrdered": "lu-list-ordered",
  "LuListTree": "lu-list-tree",
  "LuMessageSquare": "lu-message-square",
  "LuMic": "lu-mic",
  "LuMicOff": "lu-mic-off",
  "LuMinus": "lu-minus",
  "LuMoreHorizontal": "lu-more-horizontal",
  "LuPackage": "lu-package",
  "LuPaintbrush": "lu-paintbrush",
  "LuPenLine": "lu-pen-line",
  "LuPlay": "lu-play",
  "LuPlus": "lu-plus",
  "LuRedo2": "lu-redo2",
  "LuRotateCcw": "lu-rotate-ccw",
  "LuRotateCw": "lu-rotate-cw",
  "LuSend": "lu-send",
  "LuSkipForward": "lu-skip-forward",
  "LuThumbsUp": "lu-thumbs-up",
  "LuTrophy": "lu-trophy",
  "LuUndo2": "lu-undo2",
  "LuWholeWord": "lu-whole-word",
  "LuX": "lu-x",
  "MdAdd": "md-add",
  "MdAlternateEmail": "md-alternate-email",
  "MdAutoStories": "md-auto-stories",
  "MdBackspace": "md-backspace",
  "MdBiotech": "md-biotech",
  "MdBugReport": "md-bug-report",
  "MdCenterFocusStrong": "md-center-focus-strong",
  "MdChat": "md-chat",
  "MdCheck": "md-check",
  "MdChevronLeft": "md-chevron-left",
  "MdChevronRight": "md-chevron-right",
  "MdClose": "md-close",
  "MdCollectionsBookmark": "md-collections-bookmark",
  "MdContentCopy": "md-content-copy",
  "MdDarkMode": "md-dark-mode",
  "MdDataObject": "md-data-object",
  "MdDeleteOutline": "md-delete-outline",
  "MdDragIndicator": "md-drag-indicator",
  "MdEdit": "md-edit",
  "MdEditDocument": "md-edit-document",
  "MdFavoriteBorder": "md-favorite-border",
  "MdFlightTakeoff": "md-flight-takeoff",
  "MdGesture": "md-gesture",
  "MdGridView": "md-grid-view",
  "MdHeadsetOff": "md-headset-off",
  "MdHistory": "md-history",
  "MdImage": "md-image",
  "MdInfoOutline": "md-info-outline",
  "MdInsights": "md-insights",
  "MdKeyboardHide": "md-keyboard-hide",
  "MdLanguage": "md-language",
  "MdLightMode": "md-light-mode",
  "MdLightbulbOutline": "md-lightbulb-outline",
  "MdLockOutline": "md-lock-outline",
  "MdMap": "md-map",
  "MdMemory": "md-memory",
  "MdMenu": "md-menu",
  "MdMenuBook": "md-menu-book",
  "MdMicNone": "md-mic-none",
  "MdMicOff": "md-mic-off",
  "MdMyLocation": "md-my-location",
  "MdOpenInNew": "md-open-in-new",
  "MdPalette": "md-palette",
  "MdPersonOutline": "md-person-outline",
  "MdPhoneIphone": "md-phone-iphone",
  "MdPlaylistAdd": "md-playlist-add",
  "MdQuestionMark": "md-question-mark",
  "MdRecordVoiceOver": "md-record-voice-over",
  "MdRefresh": "md-refresh",
  "MdRemove": "md-remove",
  "MdSchedule": "md-schedule",
  "MdSchool": "md-school",
  "MdScreenShare": "md-screen-share",
  "MdSearch": "md-search",
  "MdSettings": "md-settings",
  "MdSort": "md-sort",
  "MdSystemUpdate": "md-system-update",
  "MdTextFields": "md-text-fields",
  "MdTune": "md-tune",
  "MdViewStream": "md-view-stream",
  "MdVolumeOff": "md-volume-off",
  "MdVolumeUp": "md-volume-up",
  "MdZoomOutMap": "md-zoom-out-map",
  "MsLanguageChinesePinyin": "ms-language-chinese-pinyin",
  "PiLegoFill": "pi-lego-fill",
  "PiStackFill": "pi-stack-fill",
  "RiExpandUpDownFill": "ri-expand-up-down-fill",
  "RiExpandUpDownLine": "ri-expand-up-down-line",
  "RiSpeakLine": "ri-speak-line",
  "TbFile": "tb-file",
  "TbFileCheck": "tb-file-check",
  "TbKeyboard": "tb-keyboard",
  "TbKeyboardOff": "tb-keyboard-off",
  "TbKeyboardShow": "tb-keyboard-show",
  "TbLayoutSidebar": "tb-layout-sidebar",
  "TbLayoutSidebarFilled": "tb-layout-sidebar-filled",
  "TbLayoutSidebarRight": "tb-layout-sidebar-right",
  "TbLayoutSidebarRightFilled": "tb-layout-sidebar-right-filled",
  "TbSwipeLeft": "tb-swipe-left",
  "TbSwipeRight": "tb-swipe-right",
  "VscWholeWord": "vsc-whole-word"
}
